import { memo } from "react";

import { TotalPeopleText } from "../../components";
import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	adultNum: number;
	kidsNum: number;
	kidsNumAsCosleeping: number;
	kidsAgeArray: Array<number>;
};

export const PeopleOfBasicInfoCompositions = memo(({ adultNum, kidsNum, kidsNumAsCosleeping, kidsAgeArray }: Props) => {
	return (
		<BasicInfoLabelWithTextLayout
			label="人数"
			textChildren={
				<TotalPeopleText
					adultNum={adultNum}
					kidsNum={kidsNum}
					kidsNumAsCosleeping={kidsNumAsCosleeping}
					kidsAgeArray={kidsAgeArray}
				/>
			}
		/>
	);
});
